module.exports = __webpack_public_path__ + "img/Voiture.5102fb20.png";